import axios from 'axios'
import { apiUrl } from 'lib/@getethos/urls/urls'

import GetSiteUrls from '@/components/global/SiteUrls'

export const validatePhoneTwilio = async (phoneNumber: string) => {
  const { ConfigSiteApiUrl } = GetSiteUrls()
  const url = apiUrl.getValidatePhoneUrl(ConfigSiteApiUrl)

  const response = await axios.post(
    url,
    {
      phoneNumber: phoneNumber,
    },
    {
      withCredentials: true,
    }
  )

  return { response: response.data }
}
